import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { PrismicLink, WrapText } from '@landsbankinn/prismic';
import {
  ArrowButton,
  device,
  typography,
  mobileGutterMargin,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React, { forwardRef } from 'react';
import { animated } from 'react-spring';
import type { ImgSource, ImgAr } from '../../components/img/Img';
import { Img } from '../../components/img/Img';

export const QuoteHost = styled(animated.div, {
  shouldForwardProp: shouldForwardProp('div'),
})<any>`
  display: block;
  position: relative;
  width: auto;

  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};
  background-color: ${(props) => props.theme.colors.primary};
  display: flex;
  color: #fff;

  flex-direction: column-reverse;
  max-width: 1179px;

  ${mobileGutterMargin}

  @media ${device.tablet} {
    flex-direction: ${(props) => (!props.reverse ? 'row' : 'row-reverse')};
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`;

const Image = styled(Img)`
  width: 100%;

  @media ${device.tablet} {
    width: 50%;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: ${(props) => `0 ${props.theme.containerGutter}px`};

  @media ${device.mobile} {
    padding: ${(props) => `0 ${props.theme.breakpoints.sm.gutter}px`};
  }

  @media ${device.tablet} {
    width: 50%;
    padding: 0;
  }
`;

const Copy = styled.div`
  div {
    ${typography.bodyEditorial};
    font-size: 20px;

    line-height: ${30 / 26};

    @media ${device.mobile} {
      font-size: 26px;
    }

    @media ${device.tablet} {
      font-size: 18px;
    }

    @media ${device.desktop} {
      font-size: 26px;
    }
  }
  margin-bottom: 80px;
`;

const Center = styled.div`
  margin: 0 auto;
  padding: 4em 0;
  max-width: 100%;

  @media ${device.tablet} {
    padding: 2.5em;
    height: 100%;

    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  @media ${device.desktop} {
    padding: 100px 100px 70px;
  }
`;

export interface CardProps {
  link?: Prismic.Link;
  linkText?: string;
  description: React.ReactNode;
  image?: ImgSource;
  ar?: ImgAr;
  reverse?: boolean;
  ref: React.LegacyRef<any>;
  style?: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
}

export const QuoteCard = forwardRef(function QCard(
  {
    link,
    linkText,
    description,
    image,
    ar = 'ar_1_1',
    reverse = false,
    ...rest
  }: CardProps,
  ref,
) {
  return (
    <QuoteHost reverse={reverse} {...rest} ref={ref}>
      {!!image && (
        <Image percentage={0.5} src={image} aspectRatio={1} ar={ar} />
      )}
      <Body>
        <Center>
          <Copy>{description}</Copy>
          <PrismicLink value={link} title={linkText}>
            <ArrowButton isWhite />
          </PrismicLink>
        </Center>
      </Body>
    </QuoteHost>
  );
});
